var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame2147207308(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3432_9761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.91016 4.46875V13H7.7793V4.46875H8.91016ZM18.2793 4.46875V13H17.1426L12.8477 6.41992V13H11.7168V4.46875H12.8477L17.1602 11.0664V4.46875H18.2793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70703 14.1719H19.2871V14.7578H6.70703V14.1719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("a", {
    href: "https://www.youtube.com/@djedouboumkarbet7662"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    x: 6.70703,
    y: 1.96875,
    width: 12.5801,
    height: 14.0625
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3432_9761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8262 0.186523C12.8848 0.186655 12.9715 0.186974 13.082 0.1875C13.3033 0.188553 13.6217 0.191104 14.0098 0.195312C14.7864 0.203736 15.8426 0.220233 16.96 0.253906C18.0774 0.287588 19.2548 0.338498 20.2754 0.414062C21.3014 0.490038 22.1531 0.590272 22.6279 0.719727H22.6289C23.1376 0.857453 23.601 1.12637 23.9736 1.49902C24.2997 1.82513 24.5466 2.22058 24.6953 2.65527L24.7529 2.84375C25.5845 6.19553 25.3939 11.5115 24.7666 15.0166C24.6283 15.5224 24.3611 15.9837 23.9902 16.3545C23.664 16.6807 23.268 16.9275 22.833 17.0762L22.6445 17.1338C22.1698 17.2633 21.3182 17.3635 20.292 17.4395C19.2712 17.515 18.0933 17.5659 16.9756 17.5996C15.8582 17.6333 14.802 17.6498 14.0254 17.6582C13.6373 17.6624 13.3188 17.664 13.0977 17.665C12.9871 17.6656 12.9004 17.6659 12.8418 17.666H12.6631C12.6044 17.6659 12.5177 17.6656 12.4072 17.665C12.186 17.664 11.8675 17.6624 11.4795 17.6582C10.7029 17.6498 9.64664 17.6333 8.5293 17.5996C7.41167 17.5659 6.23362 17.515 5.21289 17.4395C4.31484 17.3729 3.55065 17.2877 3.05566 17.1807L2.86035 17.1338L2.67188 17.0762C2.23722 16.9275 1.84172 16.6805 1.51562 16.3545C1.18942 16.0283 0.942669 15.6321 0.793945 15.1973L0.736328 15.0088C-0.0997533 11.6732 0.1266 6.35548 0.72168 2.85254C0.859973 2.34679 1.12822 1.88548 1.49902 1.51465C1.87158 1.14217 2.33525 0.874029 2.84375 0.736328L2.84473 0.735352C3.31975 0.605876 4.17133 0.505233 5.19727 0.427734C6.21815 0.350618 7.39591 0.297444 8.51367 0.261719C9.63115 0.226003 10.6872 0.207218 11.4639 0.197266C11.852 0.192292 12.1703 0.189975 12.3916 0.188477C12.5022 0.187727 12.5888 0.186774 12.6475 0.186523H12.8262Z",
    fill: "#FF0000",
    stroke: "white",
    strokeWidth: 0.375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2031 12.7527L16.8087 8.92663L10.2031 5.10059V12.7527Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3432_9761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3432_9761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 17.9262,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2147207308);
export default __webpack_public_path__ + "static/media/Frame 2147207308.31194c7960fb6f1993ac50039623dc01.svg";
export { ForwardRef as ReactComponent };